'use strict';

var _createClass = function () {
  function a(a, b) {
    for (var c, d = 0; d < b.length; d++) c = b[d], c.enumerable = c.enumerable || !1, c.configurable = !0, 'value' in c && (c.writable = !0), Object.defineProperty(a, c.key, c);
  }
  return function (b, c, d) {
    return c && a(b.prototype, c), d && a(b, d), b;
  };
}();
Object.defineProperty(exports, '__esModule', {
  value: !0
});
function _toConsumableArray(a) {
  if (Array.isArray(a)) {
    for (var b = 0, c = Array(a.length); b < a.length; b++) c[b] = a[b];
    return c;
  }
  return Array.from(a);
}
function _classCallCheck(a, b) {
  if (!(a instanceof b)) throw new TypeError('Cannot call a class as a function');
}
var MatchHeight = exports.MatchHeight = function () {
  function a(b, c) {
    var d = this;
    _classCallCheck(this, a), this.defaults = {
      timeout: 250
    }, this.options = Object.assign(this.defaults, c), this.$els = document.querySelectorAll(b), this.$elsArray = Array.prototype.slice.call(this.$els), this.getAndSet(this.$elsArray), this.debounceHeight = this.debounce(function () {
      d.getAndSet(d.$elsArray);
    }, this.options.timeout), window.addEventListener('resize', function () {
      d.debounceHeight();
    });
  }
  return _createClass(a, [{
    key: 'getAndSet',
    value: function d(a) {
      var b = Math.max;
      a.forEach(function (a) {
        return a.removeAttribute('style');
      });
      var c = b.apply(Math, _toConsumableArray(a.map(function (a) {
        return a.clientHeight;
      })));
      a.forEach(function (a) {
        Object.assign(a.style, {
          height: c + 'px',
          verticalAlign: 'top'
        });
      });
    }
  }, {
    key: 'debounce',
    value: function g(a, b, c) {
      var d = this,
        e = arguments,
        f = void 0;
      return function () {
        var g = d,
          h = e,
          i = c && !f;
        clearTimeout(f), f = setTimeout(function b() {
          f = null, c || a.apply(g, h);
        }, b), i && a.apply(g, h);
      };
    }
  }]), a;
}();